module.exports = __webpack_public_path__ + "static/media/sj_swiper.26149e77.jpg";